import React from 'react';
import { AddCircle } from '@mui/icons-material';
import { ListingForm } from 'components/shared/TableListing';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { AttributeCellFields } from './AttributeCellField';
import { StagesFormValues } from '../../../../../types';

interface Props {
  isEdit: boolean;
  rowIndex: number;
  disabled?: boolean;
  prefix: keyof Omit<StagesFormValues, 'name' | 'id' | 'winProbability'>;
}

export const AttributeCell = ({ isEdit, rowIndex, prefix, disabled = false }: Props) => {
  const { control } = useFormContext<ListingForm<StagesFormValues>>();
  const { fields, remove, append } = useFieldArray({ control, name: `bodyFields.${rowIndex}.${prefix}` });

  return (
    <Stack gap="0.5rem" width="100%" height="100%">
      <Box sx={{ height: '100%' }}>
        <RenderWithCondition
          condition={!!fields.length}
          fallBack={<Typography color="textDisabled">List empty</Typography>}
        >
          {fields.map((field, attributeIndex) => (
            <AttributeCellFields
              key={field.id}
              prefix={prefix}
              isEdit={isEdit}
              rowIndex={rowIndex}
              disabled={disabled || isEdit}
              attributeIndex={attributeIndex}
              onRemove={() => {
                remove(attributeIndex);
              }}
            />
          ))}
        </RenderWithCondition>
      </Box>

      {!isEdit && (
        <Box>
          <Button
            size="small"
            disabled={disabled}
            startIcon={<AddCircle fontSize="small" />}
            onClick={() => append({ name: '', isRequired: false, value: false })}
          >
            Add
          </Button>
        </Box>
      )}
    </Stack>
  );
};
